import "./ConversationPath.css"
import TextInput from "/src/components/UI/TextField/TextInput";
import '/src/features/chatbox/components/ChatboxPath/ChatboxPath.css';

const ConversationPath = ({ block, bot }) => {

    const url = `${location.protocol}//${location.host}/company/${bot.company.name}/bots/${bot.name}?#${block?.object_id}`;
    return (
        <div className="conversation_log_container_variable">
            <div className="chatbox_path_container">
                <div className={"chatbox_path_icon " + block?.type.name + "_icon"}></div>
                <a href={url} target='_blank'> <span className={"hover_label_path " + block?.type.name + "_label_path"}> {block?.name}</span></a>
            </div>
        </div>
    );
};

export default ConversationPath;